export const getSubscriptionDetails = () => {
  try {
    const userSession = localStorage.getItem("user");
    if (!userSession) return { discountPercent: 0, isEligible: false };
    
    const user = JSON.parse(userSession);
    
    // Core Check: If not a subscriber, no discount
    if (String(user.is_subscriber) !== "1") {
      return { discountPercent: 0, isEligible: false };
    }

    // NEW LOGIC: Duration based percentages
    // 3 Months -> 18%, 6 Months -> 22%, 1 Year -> 25%
    const duration = String(user.plan_duration || "").toLowerCase();
    let pct = 0;

    if (duration.includes("3")) {
      pct = 18;
    } else if (duration.includes("6")) {
      pct = 22;
    } else if (duration.includes("12") || duration.includes("year") || duration.includes("1")) {
      pct = 25;
    } else {
      // Fallback to your existing plan-based defaults if duration string is missing
      const planId = String(user.plan_id);
      if (planId === "1") pct = 18; // Defaulting to lowest tier
      else if (planId === "2") pct = 22;
      else if (planId === "3") pct = 25;
    }

    return {
      discountPercent: pct,
      isEligible: pct > 0,
      duration: duration
    };
  } catch (error) {
    console.error("Discount Calculation Error:", error);
    return { discountPercent: 0, isEligible: false };
  }
};